import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-animaux',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-animaux.component.html',
  styleUrls: ['./assurance-animaux.component.scss']
})
export class AssuranceAnimauxComponent {
  title = 'Assurance Chiens - Chats - Animaux';
  subtitle = '';
  heroImage = 'assets/static_pages_images/ChienChat.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Animaux', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Dommages-Ouvrage',
    link: '/assurance-dommages-ouvrage'
  };

  nextPage = { 
    title: 'Assurance Vélo - Trottinette Électrique',
    link: '/assurance-velo-trottinette'
  };

  constructor(private router: Router) {}
}
